import * as React from "react";
import { forwardRef } from "react";
const SvgIcCalendar24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 1L4 2V4H0V23H24V4H20V2L19 1H18L17 2V4H7V2L6 1H5ZM22 21V18H16V21H22ZM15 21V18L9 18V21H15ZM8 21V18H2V21H8ZM2 17H8V14H2V17ZM2 13H8V10H2V13ZM9 10V13L15 13V10H9ZM16 10V13H22V10H16ZM22 14H16V17H22V14ZM15 17V14L9 14V17L15 17Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcCalendar24);
export { ForwardRef as ReactComponent };
